import { SERVER_URL } from "../utils/constants";

const getPublisherTokens = async (address) => {
  const response = await fetch(
    `${SERVER_URL}/getPublisherTokens?address=${address}`,
    {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  if (response.status === 400) {
    const { errors } = await response.json();
    return { errors };
  }
  return await response.json();
};
export default getPublisherTokens;
